const ONE_SECOND = 1_000;
const ONE_MINUTE = 60_000;
const ONE_HOUR = 36_000_000;
const ONE_DAY = ONE_HOUR * 24;

export const TimeSpans = {
    OneSecond: ONE_SECOND,
    FiveSeconds: ONE_SECOND * 5,
    TenSeconds: ONE_SECOND * 10,
    FifteenSeconds: ONE_SECOND * 15,
    ThirtySeconds: ONE_SECOND * 30,

    OneMinute: ONE_MINUTE,
    FiveMinutes: ONE_MINUTE * 5,
    TenMinutes: ONE_MINUTE * 10,
    FifteenMinutes: ONE_MINUTE * 15,
    TwentyMinutes: ONE_MINUTE * 20,
    ThirtyMinutes: ONE_MINUTE * 30,
    FortyFiveMinutes: ONE_MINUTE * 45,

    OneHour: ONE_HOUR,
    TwoHours: ONE_HOUR * 2,
    SixHours: ONE_HOUR * 6,
    TwelveHours: ONE_HOUR * 12,

    OneDay: ONE_DAY,
    TwoDays: ONE_DAY * 2,
    ThreeDays: ONE_DAY * 3,

    FromSeconds: (seconds) => seconds * ONE_SECOND,
    FromMinutes: (minutes) => minutes * ONE_MINUTE,
    FromHours: (hours) => hours * ONE_HOUR,
    FromDays: (days) => days * ONE_DAY,
    FromMonths: (months) => months * 30 * ONE_DAY,
};
